const ensureMessage = (baseUrl, param, message) => {
  if (!message.trim()) {
    return baseUrl;
  }
  const encoded = encodeURIComponent(message.trim());
  return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${param}=${encoded}`;
};

const cleanId = (value) => value.trim().replace(/^@/, '');

const apps = {
  whatsapp: {
    id: 'whatsapp',
    name: 'Whatsapp',
    helper: 'Enter phone number with country code, no plus needed.',
    recipientLabel: 'Phone Number',
    recipientPlaceholder: '8801XXXXXXXXX',
    messagePlaceholder: 'Hello, I found your profile and want to connect.',
    buildLink: (recipient, message) => {
      const cleaned = recipient.replace(/\D/g, '');
      if (!cleaned) {
        return '';
      }
      return ensureMessage(`https://wa.me/${cleaned}`, 'text', message);
    }
  },
  telegram: {
    id: 'telegram',
    name: 'Telegram',
    helper: 'Enter username or channel name without @.',
    recipientLabel: 'Username',
    recipientPlaceholder: 'example_user',
    messagePlaceholder: 'Hi from my social link page!',
    buildLink: (recipient, message) => {
      const cleaned = cleanId(recipient);
      if (!cleaned) {
        return '';
      }
      return ensureMessage(`https://t.me/${cleaned}`, 'text', message);
    }
  },
  messenger: {
    id: 'messenger',
    name: 'Messenger',
    helper: 'Enter profile username or page name.',
    recipientLabel: 'Profile/Page',
    recipientPlaceholder: 'yourpage',
    messagePlaceholder: 'Welcome, message sent from my link generator.',
    buildLink: (recipient, message) => {
      const cleaned = cleanId(recipient);
      if (!cleaned) {
        return '';
      }
      return ensureMessage(`https://m.me/${cleaned}`, 'ref', message);
    }
  },
  instagram: {
    id: 'instagram',
    name: 'Instagram',
    helper: 'Enter Instagram username (without @).',
    recipientLabel: 'Username',
    recipientPlaceholder: 'yourusername',
    messagePlaceholder: 'Instagram does not support direct prefilled DM links.',
    buildLink: (recipient) => {
      const cleaned = cleanId(recipient);
      if (!cleaned) {
        return '';
      }
      return `https://instagram.com/${cleaned}`;
    }
  }
};

export const linkApps = Object.values(apps);

export const getAppById = (id) => apps[id];
